export default __webpack_public_path__ + "8cb0c903e8dbd9923afffaa3f1f9a059.png";